import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { BookingDetailsComponent } from "src/app/shared/components/booking-details/booking-details.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { CancelBookingNotesModalComponent } from "src/app/shared/components/cancel-booking-notes-modal/cancel-booking-notes-modal.component";
import { JoiningInterestDetailsComponent } from "../../new-v2-component/joining-interest-details/joining-interest-details.component";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { AddMemberComponent } from "src/app/shared/components/add-member/add-member.component";
import { AttendanceMarkerComponent } from "../../new-v2-component/attendance-marker/attendance-marker.component";
import { NotificationService } from "src/app/services/notification.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CustomSnackbarComponent } from "src/app/shared/components/custom-snackbar/custom-snackbar.component";
import { DialogService } from "src/app/providers/dialog.service";
import { AuthService } from "src/app/providers/auth.service";
import { AddJoiningInterestFromListComponent } from "../../new-v2-component/add-joining-interest-from-list/add-joining-interest-from-list.component";
import { CreateNewBookingFromListComponent } from "src/app/shared/components/create-new-booking-from-list/create-new-booking-from-list.component";

@Component({
  selector: "sm-new-show-all",
  templateUrl: "./new-show-all.component.html",
  styleUrls: ["./new-show-all.component.scss"],
})
export class NewShowAllComponent implements OnInit, OnDestroy {
  isAccessForEmployeeInvoice: boolean = false;
  queryData: any = [];

  messageList: any = [];
  attendanceList: any = [];
  tableDisplayColumns: any = [
    {
      columnName: "customer name",
      columnProperty: "customer_name",
    },
    {
      columnName: "phone",
      columnProperty: "phone",
    },
    {
      columnName: "service mode",
      columnProperty: "service_mode",
    },
    {
      columnName: "opted services",
      columnProperty: "opted_services",
    },
    {
      columnName: "opted timings",
      columnProperty: "opted_timings",
    },
    {
      columnName: "status",
      columnProperty: "item_status",
    },
  ];
  advancePaymentSettings: any = null;

  fromDate: any = new Date();
  toDate: any = new Date();
  selectedBusiness: any;
  businessListData: any = [];
  interestData: any = [];
  bookingsList: any = [];
  loader: boolean = false;
  apisub: Subscription;
  isEmployeeAndHasBusinessButDoesNotHaveAccess: boolean = false;
  constructor(
    private navservice: NavigationService,
    private router: Router,
    private _modelRef: MatDialog,
    private dialogService: DialogService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private loaderservice: LoaderServiceService,
    private apiservice: ApiService,
    private zone: NgZone,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForNewQueries();
    this.listenForNewQueriesStatusUpdate();
    this.listenForMemberBookingStatusUpdate();
    this.listenForBookingAssignmentUpdates();
    this.listenForMemberBookingAssignmentUpdates();
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST
      ) {
        this.businessListData = [];
        if (resdata.result) {
          this.businessListData = resdata.result;
          this.businessListData.forEach((element: any) => {
            // Parse if string
            element.employee_functionality_list =
              typeof element.employee_functionality_list === "string"
                ? JSON.parse(element.employee_functionality_list)
                : element.employee_functionality_list;

            const list = element.employee_functionality_list || [];

            // Set defaults
            element.member_access = 0;
            element.customer_access = 0;
            element.service_access = 0;
            element.bookings_access = 0;

            if (Array.isArray(list)) {
              list.forEach((fn: any) => {
                const access = fn?.access_status === 1 ? 1 : 0;
                const name = fn?.functionality_name || "";

                switch (name) {
                  case "Member management":
                    element.member_access = access;
                    break;

                  case "Customer management":
                    element.customer_access = access;
                    break;

                  case "Services & Packages":
                    element.service_access = access;
                    break;

                  case "Booking history":
                    element.bookings_access = access;
                    break;

                  case "Shop/In-Premise operation":
                    element.shop_bookings_access = access;
                    break;

                  case "Home service operation":
                    element.home_bookings_access = access;
                    break;

                  case "Virtual service operation":
                    element.virtual_bookings_access = access;
                    break;

                  case "Invoice history":
                    element.invoice_history_access = access;
                    break;

                  case "Shop/In-Premise Invoicing":
                    element.shop_invoice_access = access;
                    break;

                  case "Home service invoicing":
                    element.home_invoice_access = access;
                    break;

                  case "Virtual service invoicing":
                    element.virtual_invoice_access = access;
                    break;
                }
              });
            }
          });

          let checkForAccessLength = this.businessListData.length;
          this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0, // Add the isSelected property
            }))
            .filter(
              (element: any) =>
                element.is_owner == 1 ||
                (element.entitySubscriptionInfo &&
                  element.entitySubscriptionInfo !== "null" &&
                  element.employeeSubscriptionInfo &&
                  element.employeeSubscriptionInfo !== "null" &&
                  element.employee_status == 1 &&
                  element.bookings_access == 1)
            );
          if (checkForAccessLength - this.businessListData.length > 0) {
            this.isEmployeeAndHasBusinessButDoesNotHaveAccess = true;
          }
          if (this.businessListData.length > 0) {
            if (
              sessionStorage.getItem("newBookingForList") &&
              sessionStorage.getItem("newBookingForList") != "null"
            ) {
              this.selectedValue = sessionStorage.getItem(
                "newSelectedValueForList"
              )
                ? sessionStorage.getItem("newSelectedValueForList")
                : "2";
              this.selectedValueForBeauty = sessionStorage.getItem(
                "newSelectedValueForList"
              )
                ? sessionStorage.getItem("newSelectedValueForList") == "1"
                  ? "2"
                  : "1"
                : "1";
              const index = this.businessListData.findIndex(
                (item: any) =>
                  item.hash_id == sessionStorage.getItem("newBookingForList")
              );
              if (index != -1) {
                this.businessListData[index].isSelected = 1;
                this.selectedBusiness = this.businessListData[index];
                sessionStorage.removeItem("newBookingForList");
                sessionStorage.removeItem("newSelectedValueForList");
              } else {
                this.businessListData[0].isSelected = 1;
                this.selectedBusiness = this.businessListData[0];
              }
            } else {
              this.businessListData[0].isSelected = 1;
              this.selectedBusiness = this.businessListData[0];
            }
            localStorage.setItem(
              SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
              this.selectedBusiness.entity_public_hash_id
            );
            sessionStorage.setItem(
              "shop_service_status",
              this.selectedBusiness.shop_service_status
            );
            sessionStorage.setItem(
              "home_service_status",
              this.selectedBusiness.home_service_status
            );
            sessionStorage.setItem(
              "virtual_service_status",
              this.selectedBusiness.virtual_service_status
            );

            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_OPERATION_ACCESS,
              this.selectedBusiness.shop_bookings_access
            );
            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_OPERATION_ACCESS,
              this.selectedBusiness.home_bookings_access
            );
            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_OPERATION_ACCESS,
              this.selectedBusiness.virtual_bookings_access
            );

            localStorage.setItem(
              SM_CONSTANTS.CURRENT_ENTITY_HASH,
              this.selectedBusiness.hash_id
            );
            localStorage.setItem(
              SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
              this.selectedBusiness.employee_hash_id
            );
            sessionStorage.setItem(
              "isEntityIndividual",
              this.selectedBusiness.revenue_model == 2 ? "1" : "0"
            );
            let isEntityForeign =
              this.selectedBusiness.currency == "INR" ? "0" : "1";

            localStorage.setItem(
              SM_CONSTANTS.IS_ENTITY_FOREIGN,
              isEntityForeign
            );
            let countryList: any[] = COUNTRY_CODES;

            let selectedCurrency = {
              currency: this.selectedBusiness.currency,
              currencySymbol: this.selectedBusiness.currency_symbol,
              countryCode: this.selectedBusiness.entity_country_code,
              code: countryList.find(
                (country) =>
                  country.dial_code ===
                    this.selectedBusiness.entity_country_code &&
                  country.currency === this.selectedBusiness.currency
              )?.code,
            };
            sessionStorage.setItem(
              SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
              JSON.stringify(selectedCurrency)
            );
          }
        }
        if (this.selectedBusiness) {
          this.authService.setUserRole(
            this.selectedBusiness.is_owner == 1 ? "owner" : "employee"
          );
          if (this.selectedBusiness?.is_owner == 1) {
            this.isAccessForEmployeeInvoice = true;
          } else {
            const ssa = this.selectedBusiness.shop_bookings_access;
            const hsa = this.selectedBusiness.home_bookings_access;
            const vsa = this.selectedBusiness.virtual_bookings_access;

            const bsss = this.selectedBusiness.shop_service_status;
            const bhss = this.selectedBusiness.home_service_status;
            const bvss = this.selectedBusiness.virtual_service_status;

            // sessionStorage.getItem() returns a string or null.

            // 2. Check if ANY of the retrieved values is the string '1'
            if (
              (ssa == "1" && bsss != "2") ||
              (hsa == "1" && bhss != "2") ||
              (vsa == "1" && bvss != "2")
            ) {
              this.isAccessForEmployeeInvoice = true;
            }
          }

          this.selectedBusiness.advance_payment_settings =
            typeof this.selectedBusiness.advance_payment_settings == "string"
              ? JSON.parse(this.selectedBusiness.advance_payment_settings)
              : this.selectedBusiness.advance_payment_settings;

          if (this.selectedBusiness.advance_payment_settings) {
            this.advancePaymentSettings =
              this.selectedBusiness.advance_payment_settings;
            sessionStorage.setItem(
              SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS,
              JSON.stringify(this.selectedBusiness.advance_payment_settings)
            );
          } else {
            sessionStorage.removeItem(
              SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS
            );
          }
        }
        if (this.businessListData.length > 0) {
          if (this.selectedBusiness.revenue_model == 1) {
            if (
              !this.selectedValueForBeauty ||
              this.selectedValueForBeauty == ""
            ) {
              this.selectedValueForBeauty = "1";
            }
            if (this.selectedValueForBeauty == "1") {
              this.apiservice.getBookingsList(
                this.selectedBusiness.hash_id,
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate)
              );
            } else if (this.selectedValueForBeauty == "2") {
              this.apiservice.getAllEnrollInterestByEntityId(
                this.selectedBusiness.hash_id,
                "1",
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate),
                this.pageNo.toString(),
                "4"
              );
            } else if (this.selectedValueForBeauty == "3") {
              this.apiservice.getEntityEnquiryList(
                this.selectedBusiness.hash_id,
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate),
                "3"
              );
            }
          } else if (this.selectedBusiness.revenue_model == 2) {
            if (!this.selectedValue || this.selectedValue == "") {
              this.selectedValue = "3";
            }
            if (this.selectedValue == "1") {
              this.apiservice.getAllEnrollInterestByEntityId(
                this.selectedBusiness.hash_id,
                "1",
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate),
                this.pageNo.toString(),
                "4"
              );
            } else if (this.selectedValue == "2") {
              this.apiservice.getHistoricBookingListForFitnessEntity(
                this.selectedBusiness.hash_id,
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate)
              );
            } else if (this.selectedValue == "3") {
              this.fromDate = new Date();
              this.toDate = new Date();
              // this.fromDate.setDate(this.fromDate.getDate() - 90);
              this.apiservice.getHistoricAttendanceListForFitnessEntity(
                this.selectedBusiness.hash_id,
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate)
              );
            }
          }
        } else {
          this.loaderservice.showLoader = false;
          this.loader = false;
        }
      }
      if (resdata.responseType === SM_CONSTANTS.GET_BOOKINGS_LIST_RESULT) {
        console.log(resdata);
        this.bookingsList = resdata.result ? resdata.result : [];
        this.bookingsList = this.bookingsList.sort(
          (dataA: any, dataB: any) =>
            +new Date(dataB["bookingDate"]) - +new Date(dataA["bookingDate"])
        );
        // this.bookingsList = this.sortObjectsDescendingByBookingDate(this.bookingsList)
        this.bookingsList.forEach((element: any) => {
          if (element.customerInfo) {
            element.customerInfo = JSON.parse(element.customerInfo);
            element.customerName = element.customerInfo.name
              ? element.customerInfo.name
              : "New Customer";
            element.customerPhone = element.customerInfo.phone;
          }

          if (element.serviceInfo) {
            if (element.serviceInfo != null) {
              element.servicesCount = element.serviceInfo.length;
            }
          }
          if (element.custom_items) {
            if (element.custom_items != null) {
              element.custom_items =
                typeof element.custom_items == "string"
                  ? JSON.parse(element.custom_items)
                  : element.custom_items;
              element.customItemsArray = [];
              element.serviceInfo.forEach((item: any) => {
                element.customItemsArray.push(" " + item.item_name);
              });
            }
          }

          if (element.bookingType == 0) {
            element.booking_type = "Home service";
          } else if (element.bookingType == 1) {
            element.booking_type = "Shop service";
          } else if (element.bookingType == 2) {
            element.booking_type = "Virtual service";
          }

          if (element.paymentStatus === 0) {
            element.paymentStat = "Due";
          } else if (element.paymentStatus == 1) {
            element.paymentStat = "Done";
          } else if (element.paymentStatus == 2) {
            element.paymentStat = "Payment in progress";
          } else if (element.paymentStatus == 3) {
            element.paymentStat = "Error in payment";
          } else {
            element.paymentStat = "---";
          }

          // }

          if (element.bookingStartTime && element.bookingStartTime != null) {
            element.bookingStartTime = element.bookingStartTime.slice(0, 5);
          }
          if (element.bookingEndTime && element.bookingEndTime != null) {
            element.bookingEndTime = element.bookingEndTime.slice(0, 5);
          }

          if (
            element.bookingStatus == 0 ||
            element.bookingStatus == 1 ||
            element.bookingStatus == 2
          ) {
            element.bookingStat = "New booking";
          } else if (element.bookingStatus == 3) {
            element.bookingStat = "Under process";
          } else if (element.bookingStatus == 4) {
            element.bookingStat = "Completed";
          } else if (element.bookingStatus == 5) {
            element.bookingStat = "Booking confirmed";
          } else if (element.bookingStatus == 6) {
            element.bookingStat = "Cancelled by User";
          } else if (element.bookingStatus == 7) {
            element.bookingStat = "Assigned";
          } else if (element.bookingStatus == 8) {
            element.bookingStat = "Cancelled";
          } else if (element.bookingStatus == 9) {
            element.bookingStat = "Partially Complete";
          }

          const currentDate = new Date();
          const newDate = new Date(currentDate.toISOString().slice(0, 10));
          const bookingDate = new Date(element.bookingDate);
          console.log(bookingDate >= newDate);

          if (bookingDate >= newDate) {
            element.toshowOptions = 1;
          } else {
            element.toshowOptions = 0;
          }
        });

        console.log(this.bookingsList);

        this.apiservice.getBillDiscountData(
          this.selectedBusiness.entity_public_hash_id
        );
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_HISTORIC_BOOKING_LIST_FOR_FITNESS_ENTITY
      ) {
        console.log(resdata);
        this.messageList = resdata.result ? resdata.result : [];
        //     this.messageList =     this.messageList.sort((dataA:any, dataB:any) =>
        //     ((+new Date(dataB['bookingDate'])) - (+new
        //     Date(dataA['bookingDate'])))

        //  )
        // this.messageList = this.sortObjectsDescendingByBookingDate(this.messageList)
        this.messageList.forEach((element: any) => {
          if (element.data_type == 1) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name
                ? element.customerInfo.name
                : "New Customer";
              element.customerPhone = element.customerInfo.phone;
            }

            if (element.serviceInfo) {
              if (element.serviceInfo != null) {
                element.serviceInfo =
                  typeof element.serviceInfo == "string"
                    ? JSON.parse(element.serviceInfo)
                    : element.serviceInfo;
                element.servicesCount = element.serviceInfo.length;
              }
            }

            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }

            if (element.bookingType == 0) {
              element.booking_type = "Home service";
            } else if (element.bookingType == 1) {
              element.booking_type = "Shop service";
            } else if (element.bookingType == 2) {
              element.booking_type = "Virtual service";
            }

            if (element.paymentStatus === 0) {
              element.paymentStat = "Due";
            } else if (element.paymentStatus == 1) {
              element.paymentStat = "Done";
            } else if (element.paymentStatus == 2) {
              element.paymentStat = "Payment in progress";
            } else if (element.paymentStatus == 3) {
              element.paymentStat = "Error in payment";
            } else {
              element.paymentStat = "---";
            }

            // }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            }
            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            }

            if (
              element.bookingStatus == 0 ||
              element.bookingStatus == 1 ||
              element.bookingStatus == 2
            ) {
              element.bookingStat = "New booking";
            } else if (element.bookingStatus == 3) {
              element.bookingStat = "Under process";
            } else if (element.bookingStatus == 4) {
              element.bookingStat = "Completed";
            } else if (element.bookingStatus == 5) {
              element.bookingStat = "Booking confirmed";
            } else if (element.bookingStatus == 6) {
              element.bookingStat = "Cancelled by User";
            } else if (element.bookingStatus == 7) {
              element.bookingStat = "Assigned";
            } else if (element.bookingStatus == 8) {
              element.bookingStat = "Cancelled";
            } else if (element.bookingStatus == 9) {
              element.bookingStat = "Partially Complete";
            }

            const currentDate = new Date();
            const newDate = new Date(currentDate.toISOString().slice(0, 10));
            const bookingDate = new Date(element.bookingDate);
            console.log(bookingDate >= newDate);

            if (bookingDate >= newDate) {
              element.toshowOptions = 1;
            } else {
              element.toshowOptions = 0;
            }
          }
          if (element.data_type == 2) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name
                ? element.customerInfo.name
                : "New Customer";
              element.customerPhone = element.customerInfo.phone;
            }
            element.servicesCount = element.serviceInfo.split(",").length;

            element.price = element.price;
            // element.employeeName = '---'
            //   if(element.serviceInfo){
            //    if(element.serviceInfo!= null){
            //     element.serviceInfo = typeof element.serviceInfo == 'string' ? JSON.parse(element.serviceInfo) : element.serviceInfo
            //      element.servicesCount = element.serviceInfo.length
            //    }
            //  }

            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }

            if (element.bookingType == 0) {
              element.booking_type = "Home service";
            } else if (element.bookingType == 1) {
              element.booking_type = "Shop service";
            } else if (element.bookingType == 2) {
              element.booking_type = "Virtual service";
            } else {
              element.booking_type = "---";
            }

            if (element.paymentStatus === 0) {
              element.paymentStat = "Due";
            } else if (element.paymentStatus == 1) {
              element.paymentStat = "Done";
            } else if (element.paymentStatus == 2) {
              element.paymentStat = "Payment in progress";
            } else if (element.paymentStatus == 3) {
              element.paymentStat = "Error in payment";
            } else {
              element.paymentStat = "---";
            }

            // }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            } else {
              element.bookingStartTime = "---";
            }

            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            } else {
              element.bookingEndTime = "---";
            }

            // if(element.bookingStatus == 0){
            //   element.bookingStat = 'Absent'
            // }else if(element.bookingStatus == 1){
            //   element.bookingStat = 'Present'
            // }
            // else{
            //   element.bookingStat = '---'
            // }

            if (element.bookingStatus == 0) {
              element.bookingStat = "Absent";
            } else {
              if (element.session_status == 1) {
                element.bookingStat = "Assigned";
              } else if (element.session_status == 2) {
                element.bookingStat = "In-progress";
              } else if (element.session_status == 3) {
                element.bookingStat = "Completed";
              } else if (element.bookingStatus == 1) {
                element.bookingStat = "Present";
              } else {
                element.bookingStat = "---";
              }
            }

            //  const currentDate = new Date();
            //  const newDate = new Date(currentDate.toISOString().slice(0,10))
            //  const bookingDate = new Date(element.bookingDate)
            //  console.log(bookingDate >= newDate);

            //  if (bookingDate >= newDate) {
            //      element.toshowOptions = 1
            //  } else {
            //    element.toshowOptions = 0
            //  }
          }
        });

        console.log(this.messageList);

        this.apiservice.getBillDiscountData(
          this.selectedBusiness.entity_public_hash_id
        );
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_ENQUIRY_LIST
      ) {
        this.queryData = [];
        if (resdata.result) {
          this.queryData = resdata.result;
          console.log(this.queryData);

          this.queryData.forEach((element: any) => {
            element.phone = element?.country_code + " " + element.phone;
            element.email = element.email ?? "";

            if (element.service_mode == 0) {
              element.s_mode = "Home service";
            } else if (element.service_mode == 1) {
              element.s_mode = "In-premise service";
            } else if (element.service_mode == 2) {
              element.s_mode = "Virtual service";
            }

            if (element.status == 1) {
              element.item_status = "New";
            } else if (element.status == 2) {
              element.item_status = "In progress";
            } else if (element.status == 3) {
              element.item_status = "Resolved";
            } else {
              element.item_status = "---";
            }

            if (element.enquiry_type == 1) {
              element.e_type = "Booking";
            } else if (element.enquiry_type == 2) {
              element.e_type = "Membership";
            } else if (element.enquiry_type == 3) {
              element.e_type = "Payment";
            } else if (element.enquiry_type == 4) {
              element.e_type = "Feedback";
            } else if (element.enquiry_type == 5) {
              element.e_type = "Others";
            }
          });
        }
        this.apiservice.getBillDiscountData(
          this.selectedBusiness.entity_public_hash_id
        );
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_HISTORIC_ATTENDANCE_LIST_FOR_FITNESS_ENTITY
      ) {
        console.log(resdata);
        this.attendanceList = resdata.result ? resdata.result : [];
        //     this.messageList =     this.messageList.sort((dataA:any, dataB:any) =>
        //     ((+new Date(dataB['bookingDate'])) - (+new
        //     Date(dataA['bookingDate'])))

        //  )
        // this.messageList = this.sortObjectsDescendingByBookingDate(this.messageList)
        this.attendanceList.forEach((element: any) => {
          if (element.data_type == 2) {
            if (element.customerInfo) {
              element.customerInfo = JSON.parse(element.customerInfo);
              element.customerName = element.customerInfo.name
                ? element.customerInfo.name
                : "New Customer";
              element.customerPhone = element.customerInfo.phone;
            }
            element.servicesCount = element.serviceInfo.split(",").length;

            element.price = element.price;
            // element.employeeName = '---'
            //   if(element.serviceInfo){
            //    if(element.serviceInfo!= null){
            //     element.serviceInfo = typeof element.serviceInfo == 'string' ? JSON.parse(element.serviceInfo) : element.serviceInfo
            //      element.servicesCount = element.serviceInfo.length
            //    }
            //  }

            if (element.custom_items) {
              if (element.custom_items != null) {
                element.custom_items =
                  typeof element.custom_items == "string"
                    ? JSON.parse(element.custom_items)
                    : element.custom_items;
                element.customItemsArray = [];
                element.serviceInfo.forEach((item: any) => {
                  element.customItemsArray.push(" " + item.item_name);
                });
              }
            }

            if (element.bookingType == 0) {
              element.booking_type = "Home service";
            } else if (element.bookingType == 1) {
              element.booking_type = "Shop service";
            } else if (element.bookingType == 2) {
              element.booking_type = "Virtual service";
            } else {
              element.booking_type = "---";
            }

            if (element.paymentStatus === 0) {
              element.paymentStat = "Due";
            } else if (element.paymentStatus == 1) {
              element.paymentStat = "Done";
            } else if (element.paymentStatus == 2) {
              element.paymentStat = "Payment in progress";
            } else if (element.paymentStatus == 3) {
              element.paymentStat = "Error in payment";
            } else {
              element.paymentStat = "---";
            }

            // }

            if (element.bookingStartTime && element.bookingStartTime != null) {
              element.bookingStartTime = element.bookingStartTime.slice(0, 5);
            } else {
              element.bookingStartTime = "---";
            }

            if (element.bookingEndTime && element.bookingEndTime != null) {
              element.bookingEndTime = element.bookingEndTime.slice(0, 5);
            } else {
              element.bookingEndTime = "---";
            }

            // if(element.bookingStatus == 0){
            //   element.bookingStat = 'Absent'
            // }else if(element.bookingStatus == 1){
            //   element.bookingStat = 'Present'
            // }
            // else{
            //   element.bookingStat = '---'
            // }

            if (element.bookingStatus == 0) {
              element.bookingStat = "Absent";
            } else {
              if (element.session_status == 1) {
                element.bookingStat = "Assigned";
              } else if (element.session_status == 2) {
                element.bookingStat = "In-progress";
              } else if (element.session_status == 3) {
                element.bookingStat = "Completed";
              } else if (element.bookingStatus == 1) {
                element.bookingStat = "Present";
              } else {
                element.bookingStat = "---";
              }
            }

            //  const currentDate = new Date();
            //  const newDate = new Date(currentDate.toISOString().slice(0,10))
            //  const bookingDate = new Date(element.bookingDate)
            //  console.log(bookingDate >= newDate);

            //  if (bookingDate >= newDate) {
            //      element.toshowOptions = 1
            //  } else {
            //    element.toshowOptions = 0
            //  }
          }
        });

        console.log(this.attendanceList);

        this.apiservice.getBillDiscountData(
          this.selectedBusiness.entity_public_hash_id
        );
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        if (this.selectedBusiness.revenue_model == 1) {
          if (this.selectedValueForBeauty == "1") {
            this.apiservice.getBookingsList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValueForBeauty == "2") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValueForBeauty == "3") {
            this.apiservice.getEntityEnquiryList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "3"
            );
          }
        } else if (this.selectedBusiness.revenue_model == 2) {
          if (this.selectedValue == "1") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        if (this.selectedBusiness.revenue_model == 1) {
          if (this.selectedValueForBeauty == "1") {
            this.apiservice.getBookingsList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValueForBeauty == "2") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValueForBeauty == "3") {
            this.apiservice.getEntityEnquiryList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "3"
            );
          }
        } else if (this.selectedBusiness.revenue_model == 2) {
          if (this.selectedValue == "1") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (this.selectedBusiness.revenue_model == 1) {
          if (this.selectedValueForBeauty == "1") {
            this.apiservice.getBookingsList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValueForBeauty == "2") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValueForBeauty == "3") {
            this.apiservice.getEntityEnquiryList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "3"
            );
          }
        } else if (this.selectedBusiness.revenue_model == 2) {
          if (this.selectedValue == "1") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA
      ) {
        if (this.selectedBusiness.revenue_model == 1) {
          if (this.selectedValueForBeauty == "1") {
            this.apiservice.getBookingsList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValueForBeauty == "2") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValueForBeauty == "3") {
            this.apiservice.getEntityEnquiryList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "3"
            );
          }
        } else if (this.selectedBusiness.revenue_model == 2) {
          if (this.selectedValue == "1") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_MARK_MEMBER_ATTENDANCE_STATUS
      ) {
        if (this.selectedBusiness.revenue_model == 1) {
          if (this.selectedValueForBeauty == "1") {
            this.apiservice.getBookingsList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValueForBeauty == "2") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValueForBeauty == "3") {
            this.apiservice.getEntityEnquiryList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "3"
            );
          }
        } else if (this.selectedBusiness.revenue_model == 2) {
          if (this.selectedValue == "1") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValue == "3") {
            this.apiservice.getHistoricAttendanceListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_MEMBER_ATTENDANCE_DATA_BY_ENTITY
      ) {
        if (this.selectedBusiness.revenue_model == 1) {
          if (this.selectedValueForBeauty == "1") {
            this.apiservice.getBookingsList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValueForBeauty == "2") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValueForBeauty == "3") {
            this.apiservice.getEntityEnquiryList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "3"
            );
          }
        } else if (this.selectedBusiness.revenue_model == 2) {
          if (this.selectedValue == "1") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValue == "3") {
            this.apiservice.getHistoricAttendanceListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (this.selectedBusiness.revenue_model == 1) {
          if (this.selectedValueForBeauty == "1") {
            this.apiservice.getBookingsList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValueForBeauty == "2") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValueForBeauty == "3") {
            this.apiservice.getEntityEnquiryList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "3"
            );
          }
        } else if (this.selectedBusiness.revenue_model == 2) {
          if (this.selectedValue == "1") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (this.selectedBusiness.revenue_model == 1) {
          if (this.selectedValueForBeauty == "1") {
            this.apiservice.getBookingsList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          } else if (this.selectedValueForBeauty == "2") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValueForBeauty == "3") {
            this.apiservice.getEntityEnquiryList(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "3"
            );
          }
        } else if (this.selectedBusiness.revenue_model == 2) {
          if (this.selectedValue == "1") {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              this.pageNo.toString(),
              "4"
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getHistoricBookingListForFitnessEntity(
              this.selectedBusiness.hash_id,
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate)
            );
          }
        }
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLL_INTEREST_BY_ENTITY_ID
      ) {
        this.interestData = [];
        if (resdata.result) {
          this.interestData = resdata.result;
          console.log(this.interestData);

          this.interestData.forEach((element: any) => {
            element.request_services =
              typeof element.request_services == "string"
                ? JSON.parse(element.request_services)
                : element.request_services;
            element.request_timings =
              typeof element.request_timings == "string"
                ? JSON.parse(element.request_timings)
                : element.request_timings;
            element.phone =
              element.customer_country_code + " " + element.customer_phone;

            if (element.interest_type == 0) {
              element.service_mode = "Home service";
            } else if (element.interest_type == 1) {
              element.service_mode = "In-premise service";
            } else if (element.interest_type == 2) {
              element.service_mode = "Virtual service";
            }

            if (element.enrollment_request_status == 1) {
              element.item_status = "New";
            } else if (element.enrollment_request_status == 2) {
              element.item_status = "In progress";
            } else if (element.enrollment_request_status == 3) {
              element.item_status = "Marked as enrolled";
            } else if (element.enrollment_request_status == 4) {
              element.item_status = "Cancelled";
            } else if (element.enrollment_request_status == 5) {
              element.item_status = "Enrolled";
            }

            element.opted_services = element.request_services
              ? this.getServiceNames(element.request_services)
              : "";
            element.opted_timings = element.request_timings
              ? this.formatSchedule(element.request_timings)
              : "";
          });
        }
        this.apiservice.getBillDiscountData(
          this.selectedBusiness.entity_public_hash_id
        );
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENROLL_PROGRESS_STATUS
      ) {
        if (resdata.result) {
          if (this.currentStatusOfChange == 3) {
            this.loaderservice.showLoader = false;
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Success !",
                message:
                  "The status changed to Enrolled is successfully done. Do you want to add this person as a member now?",
                cancelbtn: "I'll do later",
                okbtn: "Add as member",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((res) => {
              if (res) {
                let data = {
                  entityHash: this.selectedBusiness.hash_id,
                  memberData: this.currentMemberOfChange,
                  // serviceType: this.interestType,
                };

                let dialogref = this.dialog.open(AddMemberComponent, {
                  width: "650px",
                  data: {
                    title: "Add member",
                    ref: this.dialog,
                    data: data,
                  },
                });
                dialogref.afterClosed().subscribe((res) => {
                  if (res) {
                    this.loader = true;
                    this.loaderservice.showLoader = true;
                    this.apiservice.getAllEnrollInterestByEntityId(
                      this.selectedBusiness.hash_id,
                      "1",
                      this.formatDate1(this.fromDate),
                      this.formatDate1(this.toDate),
                      "1",
                      "4"
                    );
                  } else {
                    this.loaderservice.showLoader = true;
                    this.apiservice.getAllEnrollInterestByEntityId(
                      this.selectedBusiness.hash_id,
                      "1",
                      this.formatDate1(this.fromDate),
                      this.formatDate1(this.toDate),
                      "1",
                      "4"
                    );
                  }
                });
              } else {
                this.loaderservice.showLoader = true;
                this.apiservice.getAllEnrollInterestByEntityId(
                  this.selectedBusiness.hash_id,
                  "1",
                  this.formatDate1(this.fromDate),
                  this.formatDate1(this.toDate),
                  "1",
                  "4"
                );
              }
            });
          } else {
            this.apiservice.getAllEnrollInterestByEntityId(
              this.selectedBusiness.hash_id,
              "1",
              this.formatDate1(this.fromDate),
              this.formatDate1(this.toDate),
              "1",
              "4"
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_REQUEST_DATA
      ) {
        if (resdata.result) {
          this.apiservice.getAllEnrollInterestByEntityId(
            this.selectedBusiness.hash_id,
            "1",
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate),
            "1",
            "4"
          );
        }
      }
    });
  }
  getServiceNames(services: any) {
    console.log(services);

    return services.map((service: any) => service.service_name).join(", ");
  }

  formatTime(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }
  formatSchedule(schedule: any[]): string {
    return schedule
      .map((item) => {
        const weekday = this.getWeekdayString(item.weekday);
        const startTime = this.formatTime(item.start_time);
        const endTime = this.formatTime(item.end_time);
        return `${weekday}: ${startTime} - ${endTime}`;
      })
      .join(", ");
  }

  ngOnInit(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      queryParamsHandling: "", // Clears all other params
      replaceUrl: true,
    });
    // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH)
    this.toDate.setDate(this.fromDate.getDate() + 90);
    console.log(this.fromDate);
    console.log(this.toDate);
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.apiservice.getBasicEntityList();
  }
  createNewBusiness() {
    this.router.navigate(["/purchased-plan"]);
  }
  selectBusiness(index: any) {
    this.loader = true;
    this.selectedValue = "2";
    this.selectedValueForBeauty = "1";

    this.bookingsList = this.interestData = [];
    this.businessListData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.businessListData[index].isSelected = 1;
    this.selectedBusiness = this.businessListData[index];
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      this.selectedBusiness.entity_public_hash_id
    );
    sessionStorage.setItem(
      "shop_service_status",
      this.selectedBusiness.shop_service_status
    );
    sessionStorage.setItem(
      "home_service_status",
      this.selectedBusiness.home_service_status
    );
    sessionStorage.setItem(
      "virtual_service_status",
      this.selectedBusiness.virtual_service_status
    );

    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_OPERATION_ACCESS,
      this.selectedBusiness.shop_bookings_access
    );
    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_OPERATION_ACCESS,
      this.selectedBusiness.home_bookings_access
    );
    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_OPERATION_ACCESS,
      this.selectedBusiness.virtual_bookings_access
    );

    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_HASH,
      this.selectedBusiness.hash_id
    );
    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      this.selectedBusiness.employee_hash_id
    );
    sessionStorage.setItem(
      "isEntityIndividual",
      this.selectedBusiness.revenue_model == 2 ? "1" : "0"
    );

    this.isAccessForEmployeeInvoice = false;
    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee"
    );
    if (this.selectedBusiness.is_owner == 1) {
      this.isAccessForEmployeeInvoice = true;
    } else {
      const ssa = this.selectedBusiness.shop_bookings_access;
      const hsa = this.selectedBusiness.home_bookings_access;
      const vsa = this.selectedBusiness.virtual_bookings_access;

      const bsss = this.selectedBusiness.shop_service_status;
      const bhss = this.selectedBusiness.home_service_status;
      const bvss = this.selectedBusiness.virtual_service_status;

      // sessionStorage.getItem() returns a string or null.

      // 2. Check if ANY of the retrieved values is the string '1'
      if (
        (ssa == "1" && bsss != "2") ||
        (hsa == "1" && bhss != "2") ||
        (vsa == "1" && bvss != "2")
      ) {
        this.isAccessForEmployeeInvoice = true;
      }
    }

    this.selectedBusiness.advance_payment_settings =
      typeof this.selectedBusiness.advance_payment_settings == "string"
        ? JSON.parse(this.selectedBusiness.advance_payment_settings)
        : this.selectedBusiness.advance_payment_settings;

    if (this.selectedBusiness.advance_payment_settings) {
      this.advancePaymentSettings =
        this.selectedBusiness.advance_payment_settings;
      sessionStorage.setItem(
        SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS,
        JSON.stringify(this.selectedBusiness.advance_payment_settings)
      );
    } else {
      sessionStorage.removeItem(SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS);
    }

    let isEntityForeign = this.selectedBusiness.currency == "INR" ? "0" : "1";

    localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, isEntityForeign);

    let countryList: any[] = COUNTRY_CODES;

    let selectedCurrency = {
      currency: this.selectedBusiness.currency,
      currencySymbol: this.selectedBusiness.currency_symbol,
      countryCode: this.selectedBusiness.entity_country_code,
      code: countryList.find(
        (country) =>
          country.dial_code === this.selectedBusiness.entity_country_code &&
          country.currency === this.selectedBusiness.currency
      )?.code,
    };
    sessionStorage.setItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
      JSON.stringify(selectedCurrency)
    );
    this.loaderservice.showLoader = true;
    if (this.selectedBusiness.revenue_model == 1) {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.toDate.setDate(this.toDate.getDate() + 90);
      this.apiservice.getBookingsList(
        this.selectedBusiness.hash_id,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else if (this.selectedBusiness.revenue_model == 2) {
      this.selectedValue = "3";
      this.fromDate = new Date();
      this.toDate = new Date();
      // this.fromDate.setDate(this.fromDate.getDate() - 90);
      this.apiservice.getHistoricAttendanceListForFitnessEntity(
        this.selectedBusiness.hash_id,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    }
  }

  search() {
    const fromDate = new Date(this.fromDate);
    const toDate = new Date(this.toDate);
    const maxRange = 90;
    const range = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
    console.log(range);

    if (parseInt(range.toString()) > maxRange) {
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
        data: {
          title: "Alert",
          message:
            "The selected time frame between from date and to date should be under 90 days.",
          okbtn: "Ok",
          cancelbtn: "Cancel",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
      return;
    }

    this.loaderservice.showLoader = true;
    if (this.selectedBusiness.revenue_model == 1) {
      if (this.selectedValueForBeauty == "1") {
        this.apiservice.getBookingsList(
          this.selectedBusiness.hash_id,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      } else if (this.selectedValueForBeauty == "2") {
        this.apiservice.getAllEnrollInterestByEntityId(
          this.selectedBusiness.hash_id,
          "1",
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          this.pageNo.toString(),
          "4"
        );
      } else if (this.selectedValueForBeauty == "3") {
        this.apiservice.getEntityEnquiryList(
          this.selectedBusiness.hash_id,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          "3"
        );
      }
    } else if (this.selectedBusiness.revenue_model == 2) {
      if (this.selectedValue == "1") {
        this.apiservice.getAllEnrollInterestByEntityId(
          this.selectedBusiness.hash_id,
          "1",
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          this.pageNo.toString(),
          "4"
        );
      } else if (this.selectedValue == "2") {
        this.apiservice.getHistoricBookingListForFitnessEntity(
          this.selectedBusiness.hash_id,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      } else if (this.selectedValue == "3") {
        this.apiservice.getHistoricAttendanceListForFitnessEntity(
          this.selectedBusiness.hash_id,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      } else if (this.selectedValue == "4") {
        this.apiservice.getEntityEnquiryList(
          this.selectedBusiness.hash_id,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate),
          "3"
        );
      }
    }
  }
  selectedValue: any = null;
  pageNo: any = 1;
  changeChip(value: string) {
    this.bookingsList =
      this.interestData =
      this.messageList =
      this.queryData =
        [];
    this.selectedValue = value;
    // this.loader = true
    this.loader = true;
    this.loaderservice.showLoader = true;
    if (value == "1") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);
      this.apiservice.getAllEnrollInterestByEntityId(
        this.selectedBusiness.hash_id,
        "1",
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        this.pageNo.toString(),
        "4"
      );
    } else if (this.selectedValue == "2") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.toDate.setDate(this.toDate.getDate() + 90);
      this.apiservice.getHistoricBookingListForFitnessEntity(
        this.selectedBusiness.hash_id,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else if (this.selectedValue == "3") {
      this.fromDate = new Date();
      this.toDate = new Date();
      // this.fromDate.setDate(this.fromDate.getDate() - 90);
      this.apiservice.getHistoricAttendanceListForFitnessEntity(
        this.selectedBusiness.hash_id,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else if (this.selectedValue == "4") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);
      this.apiservice.getEntityEnquiryList(
        this.selectedBusiness.hash_id,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        "3"
      );
    }
  }

  bookingDetails(item: any) {
    // let data = {
    //   title: 'Bookings Details',
    //   ref: this._modelRef,
    //   data: item
    // }
    // this.dialogService.openFullScreenDialog(BookingDetailsComponent, data);
    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee"
    );
    this.router.navigate(["booking-details"], {
      relativeTo: this.route,
      queryParams: { bookingHash: item.hash_id, entityHash: item.entityHash },
    });
  }
  viewDetails(item: any) {
    // this.loaderservice.showLoader = true
    // let data = {
    //   data: item
    // }
    // this.dialogService.openFullScreenDialog(JoiningInterestDetailsComponent,data)
    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee"
    );
    this.router.navigate(["query-details"], {
      relativeTo: this.route,
      queryParams: { queryHash: item.hash_id, entityHash: item.entity_hash },
    });
  }
  confirmBooking(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 5,
        startTime: item.bookingStartTime.slice(0, 5),
        endTime: item.bookingEndTime.slice(0, 5),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customerInfo.phone,
        customerName: item.customerInfo.name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this.apiservice.updateBookingStatus(data);
  }

  cancelBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to cancel this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let notedialogref = this.dialog.open(CancelBookingNotesModalComponent, {
          width: "600px",
          data: {
            title: "Cancel Booking",
          },
        });
        notedialogref.afterClosed().subscribe((res) => {
          if (res) {
            let data = {
              bookingStatusInfo: {
                bookingStatus: 8,
                assignedToHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                assignedByHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                appointmentHash: item.hash_id,
                startTime: item.bookingStartTime.slice(0, 5),
                endTime: item.bookingEndTime.slice(0, 5),
                entityHash: item.entityHash,
                countryCode: item.country_code,
                customerPh: item.customerInfo.phone,
                customerName: item.customerInfo.name,
                price: item.price,
                bookingDate: item.bookingDate,
                note: item.note,
                cancellationNotes: res.notes,
                bookingType: item.bookingType,
                customerHash: item.customerInfo.hash_id,
              },
            };

            console.log(data);
            this.loaderservice.showLoader = true;
            this.apiservice.updateBookingStatus(data);
          }
        });
      }
    });
  }

  openInvoice(item: any) {
    let data = {
      title: "Invoice",
      ref: this._modelRef,
      data: item.hash_id,
    };
    this.dialogService.openFullScreenDialog(InvoiceForReportComponent, data);
  }
  formatDate(originalDate: string): string {
    const parts = originalDate.split("/");
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, "0");
    // console.log('year', yyyy)
    // console.log('month', mm)
    // console.log('day', dd)
    return `${yyyy}-${mm}-${dd}`;
  }

  formatDate1(dateStr: Date) {
    console.log(dateStr);
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }
  displayedColumns: string[] = [
    "date",
    "customerName",
    "noOfServices",
    "cost",
    "paymentStatus",
    "startTime",
    "endTime",
    "assignedTo",
    "bookingType",
    "bookingStatus",
    "actions",
  ];
  displayedColumns2: string[] = [
    "customer_name",
    "phone",
    "service_mode",
    "opted_services",
    "opted_timings",
    "customer_notes",
    "entity_reply",
  ];

  dataSource = [
    {
      date: "2024-08-01",
      customerName: "John Doe",
      noOfServices: 3,
      cost: "$150",
      bookingStatus: "Confirmed",
      paymentStatus: "Paid",
      startTime: "9:00 AM",
      endTime: "11:00 AM",
      assignedTo: "Alice Smith",
      bookingType: "In-Person",
      actions: "",
    },
    {
      date: "2024-08-02",
      customerName: "Jane Smith",
      noOfServices: 2,
      cost: "$100",
      bookingStatus: "Pending",
      paymentStatus: "Unpaid",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      assignedTo: "Bob Johnson",
      bookingType: "Online",
      actions: "",
    },
    {
      date: "2024-08-03",
      customerName: "Jane Smith",
      noOfServices: 2,
      cost: "$100",
      bookingStatus: "Pending",
      paymentStatus: "Unpaid",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      assignedTo: "Bob Johnson",
      bookingType: "Online",
      actions: "",
    },
    {
      date: "2024-08-04",
      customerName: "Jane Smith",
      noOfServices: 2,
      cost: "$100",
      bookingStatus: "Pending",
      paymentStatus: "Unpaid",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      assignedTo: "Bob Johnson",
      bookingType: "Online",
      actions: "",
    },
    {
      date: "2024-08-05",
      customerName: "Jane Smith",
      noOfServices: 2,
      cost: "$100",
      bookingStatus: "Pending",
      paymentStatus: "Unpaid",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      assignedTo: "Bob Johnson",
      bookingType: "Online",
      actions: "",
    },
    {
      date: "2024-08-02",
      customerName: "Jane Smith",
      noOfServices: 2,
      cost: "$100",
      bookingStatus: "Pending",
      paymentStatus: "Unpaid",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      assignedTo: "Bob Johnson",
      bookingType: "Online",
      actions: "",
    },
    {
      date: "2024-08-02",
      customerName: "Jane Smith",
      noOfServices: 2,
      cost: "$100",
      bookingStatus: "Pending",
      paymentStatus: "Unpaid",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      assignedTo: "Bob Johnson",
      bookingType: "Online",
      actions: "",
    },
    {
      date: "2024-08-02",
      customerName: "Jane Smith",
      noOfServices: 2,
      cost: "$100",
      bookingStatus: "Pending",
      paymentStatus: "Unpaid",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      assignedTo: "Bob Johnson",
      bookingType: "Online",
      actions: "",
    },
    {
      date: "2024-08-02",
      customerName: "Jane Smith",
      noOfServices: 2,
      cost: "$100",
      bookingStatus: "Pending",
      paymentStatus: "Unpaid",
      startTime: "10:00 AM",
      endTime: "12:00 PM",
      assignedTo: "Bob Johnson",
      bookingType: "Online",
      actions: "",
    },
    // Add more data objects as needed
  ];

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
    sessionStorage.removeItem("newBookingForList");
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.newquerysubscription) {
      this.newquerysubscription.unsubscribe();
    }
    if (this.querystatuschangedsubscription) {
      this.querystatuschangedsubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (
            payload.data.misc.entityHash == this.selectedBusiness.hash_id ||
            payload.data.misc.entityHash ==
              this.selectedBusiness.entity_public_hash_id
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              if (this.selectedBusiness.revenue_model == 1) {
                // this.loaderservice.showLoader = true;
                if (this.selectedValueForBeauty == "1") {
                  this.apiservice.getBookingsList(
                    this.selectedBusiness.hash_id,
                    this.formatDate1(this.fromDate),
                    this.formatDate1(this.toDate)
                  );
                }
              } else if (this.selectedBusiness.revenue_model == 2) {
                // if(this.selectedValue == '1'){
                //   this.apiservice.getAllEnrollInterestByEntityId(this.selectedBusiness.hash_id,'1',this.formatDate1(this.fromDate),this.formatDate1(this.toDate),this.pageNo.toString(), '4' )

                // }
                if (this.selectedValue == "2") {
                  // this.loaderservice.showLoader = true;
                  this.apiservice.getHistoricBookingListForFitnessEntity(
                    this.selectedBusiness.hash_id,
                    this.formatDate1(this.fromDate),
                    this.formatDate1(this.toDate)
                  );
                }
              }
              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
            });
            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (
            payload.data.misc.entityHash == this.selectedBusiness.hash_id ||
            payload.data.misc.entityHash ==
              this.selectedBusiness.entity_public_hash_id
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              if (this.selectedBusiness.revenue_model == 1) {
                this.loaderservice.showLoader = true;
                if (this.selectedValueForBeauty == "1") {
                  this.apiservice.getBookingsList(
                    this.selectedBusiness.hash_id,
                    this.formatDate1(this.fromDate),
                    this.formatDate1(this.toDate)
                  );
                }
              } else if (this.selectedBusiness.revenue_model == 2) {
                // if(this.selectedValue == '1'){
                //   this.apiservice.getAllEnrollInterestByEntityId(this.selectedBusiness.hash_id,'1',this.formatDate1(this.fromDate),this.formatDate1(this.toDate),this.pageNo.toString(), '4' )

                // }
                if (this.selectedValue == "2") {
                  this.loaderservice.showLoader = true;
                  this.apiservice.getHistoricBookingListForFitnessEntity(
                    this.selectedBusiness.hash_id,
                    this.formatDate1(this.fromDate),
                    this.formatDate1(this.toDate)
                  );
                }
              }
              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
            });
          }
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (
            payload.data.misc.entityHash == this.selectedBusiness.hash_id ||
            payload.data.misc.entityHash ==
              this.selectedBusiness.entity_public_hash_id
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              if (this.selectedBusiness.revenue_model == 1) {
                this.loaderservice.showLoader = true;
                if (this.selectedValueForBeauty == "1") {
                  this.apiservice.getBookingsList(
                    this.selectedBusiness.hash_id,
                    this.formatDate1(this.fromDate),
                    this.formatDate1(this.toDate)
                  );
                }
              } else if (this.selectedBusiness.revenue_model == 2) {
                // if(this.selectedValue == '1'){
                //   this.apiservice.getAllEnrollInterestByEntityId(this.selectedBusiness.hash_id,'1',this.formatDate1(this.fromDate),this.formatDate1(this.toDate),this.pageNo.toString(), '4' )

                // }
                if (this.selectedValue == "2") {
                  this.loaderservice.showLoader = true;
                  this.apiservice.getHistoricBookingListForFitnessEntity(
                    this.selectedBusiness.hash_id,
                    this.formatDate1(this.fromDate),
                    this.formatDate1(this.toDate)
                  );
                }
              }
              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
            });
          }
        }
      });
  }

  private newquerysubscription: Subscription = new Subscription();
  listenForNewQueries() {
    this.newquerysubscription = this.notificationService
      .getNotificationByType("newJoiningQuery")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          if (
            payload.data.misc.entityHash == this.selectedBusiness.hash_id ||
            payload.data.misc.entityHash ==
              this.selectedBusiness.entity_public_hash_id
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              if (this.selectedBusiness.revenue_model == 1) {
                // this.loaderservice.showLoader = true;
                // this.apiservice.getBookingsList(this.selectedBusiness.hash_id, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
              } else if (this.selectedBusiness.revenue_model == 2) {
                if (this.selectedValue == "1") {
                  // this.loaderservice.showLoader = true;
                  this.apiservice.getAllEnrollInterestByEntityId(
                    this.selectedBusiness.hash_id,
                    "1",
                    this.formatDate1(this.fromDate),
                    this.formatDate1(this.toDate),
                    this.pageNo.toString(),
                    "4"
                  );
                }
                // if(this.selectedValue == '2'){
                //   this.apiservice.getHistoricBookingListForFitnessEntity(this.selectedBusiness.hash_id, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
                // }
              }
              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
            });
          }
        }
      });
  }

  private querystatuschangedsubscription: Subscription = new Subscription();
  listenForNewQueriesStatusUpdate() {
    this.querystatuschangedsubscription = this.notificationService
      .getNotificationByType("membershipQueryStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          if (
            payload.data.misc.entityHash == this.selectedBusiness.hash_id ||
            payload.data.misc.entityHash ==
              this.selectedBusiness.entity_public_hash_id
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              if (this.selectedBusiness.revenue_model == 1) {
                // this.loaderservice.showLoader = true;
                // this.apiservice.getBookingsList(this.selectedBusiness.hash_id, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
              } else if (this.selectedBusiness.revenue_model == 2) {
                if (this.selectedValue == "1") {
                  this.loaderservice.showLoader = true;
                  this.apiservice.getAllEnrollInterestByEntityId(
                    this.selectedBusiness.hash_id,
                    "1",
                    this.formatDate1(this.fromDate),
                    this.formatDate1(this.toDate),
                    this.pageNo.toString(),
                    "4"
                  );
                }
                // if(this.selectedValue == '2'){
                //   this.apiservice.getHistoricBookingListForFitnessEntity(this.selectedBusiness.hash_id, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
                // }
              }
              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
            });
          }
        }
      });
  }
  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          if (
            payload.data.misc.entityHash == this.selectedBusiness.hash_id ||
            payload.data.misc.entityHash ==
              this.selectedBusiness.entity_public_hash_id
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              this.changeChip("2");

              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
            });
          }
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          if (
            payload.data.misc.entityHash == this.selectedBusiness.hash_id ||
            payload.data.misc.entityHash ==
              this.selectedBusiness.entity_public_hash_id
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              this.changeChip("2");

              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
            });
          }
        }
      });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/y9jYlBqYszM",
        title: "Creating Bookings/Appointments in LookzUp Business Portal. ",
      },
    });
  }

  openVideoForAttendance() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/EFIB81ov0ts",
        title: "Creating Bookings/Appointments in LookzUp Business Portal. ",
      },
    });
  }

  deleteBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          appointmentHash: item.hash_id,
          entityHash: this.selectedBusiness.hash_id,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityAppointmentData(obj);
      }
    });
  }

  selectcountry() {
    let dialogref = this.dialog.open(SelectBusinessCountryComponent, {
      maxWidth: "500px",
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Select country",
        ref: this.dialog,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.router.navigate(["purchased-plan"]);
      }
    });
  }

  currentStatusOfChange: any;
  currentMemberOfChange: any;
  changeRequestStatus(item: any, status: any) {
    let statusMessage = "";
    if (status == 1) {
      statusMessage = "Are you sure want to mark the query as new?";
    } else if (status == 2) {
      statusMessage = "Are you sure want to mark the query as in-progress?";
    } else if (status == 3) {
      statusMessage = "Are you sure want to mark the person as enrolled?";
    } else if (status == 4) {
      statusMessage = "Are you sure want to mark the query as cancelled?";
    }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message: statusMessage,
        cancelbtn: "Cancel",
        okbtn: "Confirm",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.currentStatusOfChange = status;
        this.currentMemberOfChange = item;
        let obj = {
          hash_id: item.hash_id,
          entity_hash: this.selectedBusiness.hash_id,
          status: status,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.updateEnrollInterestProgressStatus(obj);
      }
    });
  }

  deleteQuery(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this query?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.selectedBusiness.hash_id,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityRequestData(obj);
      }
    });
  }

  // BOOKING HISTORY
  bookingDetailsForHistory(item: any) {
    // let data = {
    //   title: 'Bookings Details',
    //   ref: this.dialog,
    //   data: item
    // }
    // this.dialogService.openFullScreenDialog(BookingDetailsComponent, data);
    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee"
    );
    this.router.navigate(["booking-details"], {
      relativeTo: this.route,
      queryParams: { bookingHash: item.hash_id, entityHash: item.entityHash },
    });
  }

  confirmBookingForHistory(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 5,
        startTime: item.bookingStartTime.slice(0, 5),
        endTime: item.bookingEndTime.slice(0, 5),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customerInfo.phone,
        customerName: item.customerInfo.name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this.apiservice.updateBookingStatus(data);
  }

  cancelBookingForHistory(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to cancel this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let notedialogref = this.dialog.open(CancelBookingNotesModalComponent, {
          width: "600px",
          data: {
            title: "Cancel Booking",
          },
        });
        notedialogref.afterClosed().subscribe((res) => {
          if (res) {
            let data = {
              bookingStatusInfo: {
                bookingStatus: 8,
                assignedToHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                assignedByHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                appointmentHash: item.hash_id,
                startTime: item.bookingStartTime.slice(0, 5),
                endTime: item.bookingEndTime.slice(0, 5),
                entityHash: item.entityHash,
                countryCode: item.country_code,
                customerPh: item.customerInfo.phone,
                customerName: item.customerInfo.name,
                price: item.price,
                bookingDate: item.bookingDate,
                note: item.note,
                cancellationNotes: res.notes,
                bookingType: item.bookingType,
                customerHash: item.customerInfo.hash_id,
              },
            };

            console.log(data);
            this.loaderservice.showLoader = true;
            this.apiservice.updateBookingStatus(data);
          }
        });
      }
    });
  }

  openInvoiceForHistory(item: any) {
    let data = {
      title: "Invoice",
      ref: this.dialog,
      data: item.hash_id,
    };
    this.dialogService.openFullScreenDialog(InvoiceForReportComponent, data);
  }

  deleteBookingForHistory(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          appointmentHash: item.hash_id,
          entityHash: this.selectedBusiness.hash_id,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityAppointmentData(obj);
      }
    });
  }

  changeAttendanceStatus(status: any, item: any) {
    console.log(item);

    let msg = "";
    if (status == 0) {
      msg = "Are you sure you want to mark this appointment as absent?";
    } else if (status == 1) {
      msg = "Are you sure you want to mark this appointment as present?";
    }
    const dialogRef = this.dialog.open(AttendanceMarkerComponent, {
      data: {
        title: "Alert",
        message: msg,
        status: status,
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          hash_id: item.hash_id, // only while updating the attendance status
          entity_hash: item.entityHash,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          member_hash: item.member_hash_id,
          attendance_status: status, //0-absent,1-present
          notes: result.note,
          attendance_date: this.formatDateForApi(new Date()),
        };

        Object.keys(data).forEach((key) => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });

        console.log(data);

        this.loaderservice.showLoader = true;
        this.apiservice.markMemberAttendanceStatus(data);
      }
    });
  }

  formatDateForApi(dateStr: Date) {
    // let curdate = new Date().toISOString().slice(0,10);
    // return curdate;

    let curdate = dateStr
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;

    // // Split the date string by `/`
    // const parts = dateStr.split('/');

    // // Reverse the order of the parts and join them with `-`
    // const newDateStr = parts.reverse().join('-');

    // // Return the formatted date string
    // return newDateStr;
  }

  deleteAttendance(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this member's attendance?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          entityHash: rowvalue.entityHash,
          memberHash: rowvalue.member_hash,
          attendanceHash: rowvalue.hash_id,
        };

        console.log(data);
        this.loaderservice.showLoader = true;
        this.apiservice.deleteMemberAttendanceDataByEntity(data);
      }
    });
  }
  discountInfo: any = null;
  openLink(url: string): void {
    window.open(url, "_blank");
  }

  createNewBookingFromList() {
    let data = {
      title: "New Booking",
      ref: this._modelRef,
      data: {
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
        // serviceType: this.bookingType,
        discountInfo: this.discountInfo,
        // isForTomorrow: this.selectedValue,
      },
    };

    let dialogref = this.dialogService.openFullScreenDialog(
      CreateNewBookingFromListComponent,
      data
    );
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (this.selectedBusiness.revenue_model == 1) {
          this.changeChipForBeauty("1");
        } else if (this.selectedBusiness.revenue_model == 2) {
          this.changeChip("2");
        }
      }
    });
  }

  addNewInterestFromList() {
    let data = {
      title: "New query",
      ref: this.dialog,
      data: {
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
        // serviceType: this.interestType,
      },
    };

    let dialogref = this.dialogService.openFullScreenDialog(
      AddJoiningInterestFromListComponent,
      data
    );
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (this.selectedBusiness.revenue_model == 1) {
          this.changeChipForBeauty("2");
        } else if (this.selectedBusiness.revenue_model == 2) {
          this.changeChip("1");
        }
      }
    });
  }

  selectedValueForBeauty: any = null;

  changeChipForBeauty(value: string) {
    this.bookingsList =
      this.interestData =
      this.messageList =
      this.queryData =
        [];
    this.selectedValueForBeauty = value;
    // this.loader = true
    this.loader = true;
    this.loaderservice.showLoader = true;
    if (this.selectedValueForBeauty == "1") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.toDate.setDate(this.fromDate.getDate() + 90);
      this.apiservice.getBookingsList(
        this.selectedBusiness.hash_id,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate)
      );
    } else if (this.selectedValueForBeauty == "2") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.toDate.getDate() - 90);
      this.apiservice.getAllEnrollInterestByEntityId(
        this.selectedBusiness.hash_id,
        "1",
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        this.pageNo.toString(),
        "4"
      );
    } else if (this.selectedValueForBeauty == "3") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);
      this.apiservice.getEntityEnquiryList(
        this.selectedBusiness.hash_id,
        this.formatDate1(this.fromDate),
        this.formatDate1(this.toDate),
        "3"
      );
    }
  }

  viewDetailsforservicequery(item: any) {
    // this.loaderservice.showLoader = true
    // this.dialog.open(JoiningInterestDetailsComponent,{
    //   width:'600px',
    //   disableClose:true,
    //   data: {
    //     data: item
    //   }
    // })
    this.router.navigate(["service-query-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { queryHash: item.hash_id, serviceType: "3" },
    });
  }
}
